class CartUpsell {
  constructor() {
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('click', (event) => {
      const bundleButton = event.target.closest('.cart-upsell__add-bundle');
      const singleButton = event.target.closest('.cart-upsell__add-single');

      if (bundleButton) {
        event.preventDefault();
        this.handleBundleAdd(bundleButton);
      } else if (singleButton) {
        event.preventDefault();
        this.handleSingleAdd(singleButton);
      }
    });
  }

  async handleBundleAdd(button) {
    const productHandle = button.dataset.productHandle;
    const variantId = button.dataset.variantId;
    const debugVariant = button.dataset.debugVariant;
    
    console.log('Adding bundle with:', {
      productHandle,
      variantId,
      debugVariant
    });
    
    if (!variantId) {
      console.error('No variant ID provided for bundle');
      return;
    }
    
    try {
      // First get the product data
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      
      console.log('Product data:', {
        productTitle: product.title,
        variants: product.variants.map(v => ({ id: v.id, title: v.title }))
      });

      // Find the specific variant by ID
      const variant = product.variants.find(v => v.id.toString() === variantId);

      if (!variant) {
        console.error('Variant not found:', {
          requestedVariantId: variantId,
          availableVariants: product.variants.map(v => v.id)
        });
        return;
      }

      console.log('Found variant:', {
        id: variant.id,
        title: variant.title
      });

      // Clear the cart first
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Add the bundle to cart
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1
          }]
        })
      });

      const addResult = await addResponse.json();
      console.log('Add to cart result:', addResult);

      // Trigger cart drawer refresh
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
    }
  }

  async handleSingleAdd(button) {
    const productHandle = button.dataset.productHandle;
    
    try {
      // Get the product data
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      
      // Find the default variant
      const variant = product.variants[0];
      
      if (!variant) {
        console.error('No variants found for product:', productHandle);
        return;
      }

      // Add the single product to cart
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1
          }]
        })
      });

      const addResult = await addResponse.json();
      console.log('Add to cart result:', addResult);

      // Trigger cart drawer refresh
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    } catch (error) {
      console.error('Error adding single product to cart:', error);
    }
  }
}

// Initialize the cart upsell
document.addEventListener('DOMContentLoaded', () => {
  new CartUpsell();
}); 